import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";

import CssBaseline from '@material-ui/core/CssBaseline';

import useStyles from './AppStyle';

import routes from './routes';

function App() {
  const classes = useStyles();

  return (
    <Router className={classes.root}>
      <CssBaseline />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {routes.map((route, index) => (
            <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.component}
            />
        ))}
      </main>
    </Router>
  );
}

export default App;
